"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConnectionHealthPolicy_1 = __importDefault(require("./BaseConnectionHealthPolicy"));
const VideoEncodingConnectionHealthPolicyName_1 = __importDefault(require("./VideoEncodingConnectionHealthPolicyName"));
class VideoEncodingConcurrentSendersHealthPolicy extends BaseConnectionHealthPolicy_1.default {
    constructor(configuration, data) {
        super(configuration, data, VideoEncodingConnectionHealthPolicyName_1.default.VideoConcurrentSendersHealth);
        this.concurrentVideoSendersThreshold = configuration.concurrentVideoSendersThreshold;
    }
    health() {
        if (this.currentData.isContentShare) {
            // Do not degrade content share as the number of content share senders is limited
            return this.maximumHealth();
        }
        if (this.currentData.numberOfPublishedVideoSources > this.concurrentVideoSendersThreshold) {
            return this.minimumHealth();
        }
        return this.maximumHealth();
    }
}
exports.default = VideoEncodingConcurrentSendersHealthPolicy;
//# sourceMappingURL=VideoEncodingConcurrentSendersHealthPolicy.js.map